import React from 'react';

const BtnAction = ({children, badge, bord = true, onClick}) => {
    return (
        <div onClick={onClick} style={{
            display: "inline-flex",
            padding: "4px 8px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderRadius: "2px",
            border: bord ? "1px solid #A8B0B3" : "",
            background: bord ? "#FFF" : "",
            cursor: "pointer"
        }}>
            {badge && (
                <span style={{
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    backgroundColor: "#FF5733", // Couleur du fond du badge
                    color: "#FFF", // Couleur du texte du badge
                    fontWeight: "bold",
                    fontSize: "14px",
                }}>{badge}</span>
            )}
            <span style={{
                color: "#70787B",
                textAlign: "center",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: bord ? "400" : "600",
                lineHeight: "130%"
            }}>{children}</span>
        </div>
    );
};

export default BtnAction;
